import type { IContextBuildersMap } from './helpers/build-validation-schema-from-form-elements';
import { buildDocumentFieldThisState } from './fields/DocumentField/utils/build-document-field-this-state';

export const contextBuilders: IContextBuildersMap = {
  documentfield: buildDocumentFieldThisState,
};
